<template>
    <div>
        <table class="w-full" style="max-width: 800px">
            <thead>
                <tr>
                    <th>Item Description</th>
                    <th class="text-center" style="width: 100px">Price</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in form.additional_products">
                    <td>{{ row.label }}</td>
                    <td>
                        <div class="el-input el-input--minimal-padding">
                            <money
                                v-model.number="row.value"
                                v-bind="money"
                                :disabled="!can(Permissions.EDIT_PRICING)"
                                class="text-right el-input__inner"
                            />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { Money, VMoney } from "v-money";
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    props: {
        form: {
            required: true,
            type: Object,
        },
    },
    directives: { money: VMoney },
    components: {
        Money,
    },
    data() {
        return {
            money: {
                decimal: ".",
                thousands: ",",
                prefix: "$ ",
                suffix: "",
                precision: 2,
                masked: true,
            },
        };
    },
    methods: {},
};
</script>

<style scoped></style>
